import { apiClient } from '@api/client'
import { StrengthApi } from '@api/generated'

export const strengthApi = new StrengthApi(undefined, '', apiClient)
